import { useEffect, useState } from "react";
import { IUpdateLicense } from "../UpdateLicense/interface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import "./AddUrl.scss";
import { authorizationService } from "../../../api_services/authorizationService";
import Loader from "../../Loader/Loader";
import { alertService } from "../../Services/alertService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";

const AddUrl = (props: IUpdateLicense) => {
    const { onClose, onSubmit } = props;
    const [rowsData, setRowsData] = useState<any>([]);
    const [urlData, setUrlData] = useState<any>({});
    const [inputs, setInputs] = useState<any>();
    const [submitFlag, setSubmitFlag] = useState<any>(false);
    const [loaderFlag, setLoaderFlag] = useState<boolean>(true);
    const receiveInputFields = {
        "MQTT":
            [
                { key: "MQTTHost", type: "string", required: 1 },
                { key: "MQTTPort", type: "string", required: 1 },
                { key: "userName", type: "string", required: 0 },
                { key: "password", type: "string", required: 0 },
                { key: "MQTTTopic", type: "number", required: 1 },
                { key: "ssl_tls", type: "string", required: 1, isCheckBox: true }
            ],
        "Azure":
            [
                { key: "IoTHubServer", type: "string", required: 1 },
                { key: "deviceKey", type: "string", required: 1 }
            ],
        "AWS": [
            { key: "awsMQTTAddress", type: "string", required: 1 },
            { key: "certificate", type: "string", required: 1 },
            { key: "key", type: "string", required: 1 }
        ]
    }

    let payLoad: any = getURLDataMethod();

    const options: any = [
        {
            "label": "HTTP",
            "value": "http",
            "selected": true
        },
        {
            "label": "MQTT",
            "value": "MQTT"
        },
        {
            "label": "Azure",
            "value": "Azure"
        },
        {
            "label": "AWS",
            "value": "AWS"
        }
    ]

    useEffect(() => {
        if (Object?.keys(urlData)?.length === 0) {
            getUrlData();
        }
    }, [])

    useEffect(() => {
        let temp: any = "ssl_tls";
        if (inputs?.uploadTo === "mqtt") {
            if ((temp) in inputs) {
                // console.log(inputs);
            }
            else {
                const name = "ssl_tls";
                setInputs((values: any) => ({ ...values, [name]: false }));

            }
        }
    }, [inputs?.uploadTo])

    // useEffect(() => {
    //     console.log(rowsData);
    // }, [rowsData])

    const getUrlData = async () => {
        const payload = JSON.parse(JSON.stringify(payLoad));
        if (payload && payload['firmware_version']) {
            const device = payload['device_type']?.split('iLens-')[1];
            try {
                return await authorizationService.getUrlData("GetUrlData", payload, device, payload['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body.data))
                            setLoaderFlag(false);
                            setUrlData(response);
                            if (response?.selectedUpload === "http") {
                                let reqData: any = {
                                    site_name: response?.site_name,
                                    frequency: response?.frequency,
                                    site_id: response?.site_id,
                                    project_id: response?.project_id,
                                }
                                Object.entries(response?.uploadTo)?.map((key: any, value) => {
                                    if (key[1]?.selected) {
                                        reqData["uploadTo"] = key[1]?.value
                                    }
                                    if (key[1]?.defaultValues && key[1]?.selected) {
                                        if (key[1]?.defaultValues?.url) {
                                            if (key[1]?.defaultValues?.url?.length > 0) {
                                                defaultUrl(key[1]?.defaultValues?.url);
                                            }
                                        }
                                    }
                                })
                                setInputs(reqData);
                            }
                            else if (response?.selectedUpload === "mqtt") {
                                let reqData: any = {
                                    site_name: response?.site_name,
                                    frequency: response?.frequency,
                                    site_id: response?.site_id,
                                    project_id: response?.project_id,
                                }
                                Object.entries(response?.uploadTo)?.map((key: any, value) => {
                                    if (key[1]?.selected) {
                                        reqData["uploadTo"] = key[1]?.value
                                    }
                                    if (key[1]?.defaultValues && key[1]?.selected) {
                                        reqData["MQTTHost"] = key[1]?.defaultValues?.MQTTHost;
                                        reqData["MQTTPort"] = key[1]?.defaultValues?.MQTTPort;
                                        reqData["userName"] = key[1]?.defaultValues?.userName;
                                        reqData["password"] = key[1]?.defaultValues?.password;
                                        reqData["MQTTTopic"] = key[1]?.defaultValues?.MQTTTopic;
                                        reqData["ssl_tls"] = key[1]?.defaultValues?.ssl_tls;
                                    }
                                })
                                setInputs(reqData);
                            }
                            else if (response?.selectedUpload === "azure") {
                                let reqData: any = {
                                    site_name: response?.site_name,
                                    frequency: response?.frequency,
                                    site_id: response?.site_id,
                                    project_id: response?.project_id,
                                }
                                Object.entries(response?.uploadTo)?.map((key: any, value) => {
                                    if (key[1]?.selected) {
                                        reqData["uploadTo"] = key[1]?.value
                                    }
                                    if (key[1]?.defaultValues && key[1]?.selected) {
                                        reqData["IoTHubServer"] = key[1]?.defaultValues?.IoTHubServer;
                                        reqData["deviceKey"] = key[1]?.defaultValues?.deviceKey;
                                    }
                                })
                                setInputs(reqData);
                            }
                            else if (response?.selectedUpload === "aws") {
                                let reqData: any = {
                                    site_name: response?.site_name,
                                    frequency: response?.frequency,
                                    site_id: response?.site_id,
                                    project_id: response?.project_id,
                                }
                                response?.uploadTo && Object?.entries(response?.uploadTo)?.map((key: any, value) => {
                                    if (key[1]?.selected) {
                                        reqData["uploadTo"] = key[1]?.value
                                    }
                                    if (key[1]?.defaultValues && key[1]?.selected) {
                                        reqData["awsMQTTAddress"] = key[1]?.defaultValues?.awsMQTTAddress;
                                        reqData["certificate"] = key[1]?.defaultValues?.certificate;
                                        reqData["key"] = key[1]?.defaultValues?.key;
                                    }
                                })
                                setInputs(reqData);
                            }
                            else {
                                let reqData = {
                                    site_name: response?.site_name,
                                    frequency: response?.frequency,
                                    site_id: response?.site_id,
                                    project_id: response?.project_id
                                }
                                setInputs(reqData);
                            }
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const updateUrlData = async (payLoadData: any) => {
        const payload = JSON.parse(JSON.stringify(payLoad));
        if (payload && payload['firmware_version']) {
            payload["uploader"] = payLoadData;
            const device = payLoad['device_type'].split('iLens-')[1];
            try {
                return await authorizationService.updateUrlData("UpdateUrlData", payload, device, payLoad['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            setRowsData([])
                            getUrlData()
                            alertService.serviceSuccessMessage(res.body.message)
                            let response = JSON.parse(JSON.stringify(res.body.data))
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        alertService.serviceErrorMessage(res.body.message)
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
        else {
            console.log('issue');
        }
    }

    // useEffect(() => {
    //     console.log(rowsData);
    // }, [rowsData?.length])

    const defaultUrl = (urls: any) => {
        const tempRowData: any = [];
        urls?.forEach((eachUrl: string, index: number) => {
            const rowsInput: any = {
                url: eachUrl
            }
            tempRowData.push(rowsInput)
            // setRowsData([...rowsData, rowsInput])
        })
        setRowsData(tempRowData);
    }

    const addContainerTableRows = () => {
        if (rowsData?.length <= 3) {
            const rowsInput: any = {
                url: ''
            }
            setRowsData([...rowsData, rowsInput])
        }
    }

    const deleteTableRows = (index: number) => {
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
    }

    // On changing the input fields
    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }

    const handleCheckBox = (event: any) => {
        const name = event.target.name;
        setInputs((values: any) => ({ ...values, [name]: !!event.target.checked }));
    }

    const handleChangeURL = (index: number, evnt: any) => {
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        setRowsData(rowsInput);
    }

    const validate = () => {
        let valid = true;
        let tempInputs: any = JSON.parse(JSON.stringify(inputs));
        const receiveInputFields = {
            "mqtt":
                [
                    { key: "MQTTHost", type: "string", required: 1 },
                    { key: "MQTTPort", type: "string", required: 1 },
                    { key: "userName", type: "string", required: 0 },
                    { key: "password", type: "string", required: 0 },
                    { key: "MQTTTopic", type: "number", required: 1 },
                    { key: "ssl_tls", type: "string", required: 1, isCheckBox: true }
                ],
            "azure":
                [
                    { key: "IoTHubServer", type: "string", required: 1 },
                    { key: "deviceKey", type: "string", required: 1 }
                ],
            "aws": [
                { key: "awsMQTTAddress", type: "string", required: 1 },
                { key: "certificate", type: "string", required: 1 },
                { key: "key", type: "string", required: 1 }
            ]
        }
        if (inputs?.uploadTo) {
            if (inputs?.uploadTo === "mqtt") {
                Object.entries(tempInputs)?.map((key: any, value) => {
                    const Azureind: any = receiveInputFields["azure"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (Azureind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                    const AWSind: any = receiveInputFields["aws"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (AWSind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                })
            }
            else if (inputs?.uploadTo === "azure") {
                Object.entries(tempInputs)?.map((key: any, value) => {
                    const MQTTind: any = receiveInputFields["mqtt"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (MQTTind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                    const AWSind: any = receiveInputFields["aws"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (AWSind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                })
            }
            else if (inputs?.uploadTo === "aws") {
                Object.entries(tempInputs)?.map((key: any, value) => {
                    const MQTTind: any = receiveInputFields["mqtt"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (MQTTind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                    const Azureind: any = receiveInputFields["azure"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (Azureind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                })
            }
            else if (inputs?.uploadTo === "http") {
                Object.entries(tempInputs)?.map((key: any, value) => {
                    const MQTTind: any = receiveInputFields["mqtt"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (MQTTind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                    const Azureind: any = receiveInputFields["azure"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (Azureind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                    const AWSind: any = receiveInputFields["aws"]?.findIndex((dataEle: any) => dataEle?.key === key[0])
                    if (AWSind > -1) {
                        if (key[0] in tempInputs) {
                            delete tempInputs[key[0]];
                        }
                    }
                })
            }
        }
        else {
            valid = false;
        }
        setInputs(tempInputs);
        if (inputs?.uploadTo) {
            if (inputs?.uploadTo === "mqtt") {
                return [valid, tempInputs, receiveInputFields["mqtt"]];
            }
            else if (inputs?.uploadTo === "azure") {
                return [valid, tempInputs, receiveInputFields["azure"]];
            }
            else if (inputs?.uploadTo === "aws") {
                return [valid, tempInputs, receiveInputFields["aws"]];
            }
            else {
                return [valid, tempInputs];
            }

        }

    }

    const turnToRequireStructure = (submitInputFields: any) => {
        let targetFields = JSON.parse(JSON.stringify(submitInputFields))
        let reqArray: any = [];
        rowsData?.forEach((element: any) => {
            reqArray.push(element.url);
        });
        if (inputs?.uploadTo === "http") {
            submitInputFields["url"] = reqArray;
        }
        else {
            if (submitInputFields?.url) {
                delete submitInputFields["url"];
            }
        }
        updateUrlData(submitInputFields)
        setLoaderFlag(true);
    }

    const saveAddUrl = () => {
        setSubmitFlag(true);
        let req = validate();
        let updatedInputs = req?.[1];
        let inputFields = req?.[2];
        let valid = true;
        const defaultInputs = [
            { name: "site_name", type: "string", required: 1 },
            { name: "frequency", type: "number", required: 1 },
            { name: "project_id", type: "string", required: 0 },
            { name: "site_id", type: "string", required: 0 },
            { name: "uploadTo", type: "string", required: 0 },
        ];
        if (req?.[0] && updatedInputs) {
            inputFields && inputFields.forEach((field: any) => {
                if (field.required === 1) {
                    if (field.isCheckBox === true) {
                        // console.log(field.key)
                    }
                    else if (!updatedInputs[field.key]) {
                        valid = false;
                    }
                }
            })
            defaultInputs.forEach((field: any) => {
                if (field.required === 1) {
                    if (!updatedInputs[field.name]) {
                        valid = false;
                    }
                }
            })
        }
        else {
            valid = false;
        }
        if (valid) {
            turnToRequireStructure(updatedInputs)
        }
        else {
            alertService.serviceWarningMessage("Please fill all required fields")
        }
    }

    return (
        <>
            <div className="modal-body py-3 events-none">
                {!loaderFlag ?
                    <>
                        <div className="row mb-3">
                            <div className="col-md-4 mb-3">
                                <label className="url-label">Site Name</label>
                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                <input type="text" value={inputs?.site_name} name="site_name" onChange={handleChange} className="form-control form-control-bordered" />
                                {submitFlag && !inputs?.site_name &&
                                    <div className="text-danger my-2">Please Enter Site Name</div>
                                }
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="url-label">Upload Frequency (Sec)</label>
                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                <input type="number" value={inputs?.frequency} name="frequency" onChange={handleChange} className="form-control form-control-bordered" />
                                {submitFlag && !inputs?.frequency &&
                                    <div className="text-danger my-2">Please Enter Upload Frequency</div>
                                }
                            </div>
                            {"project_id" in urlData &&
                                <div className="col-md-4 mb-3">
                                    <label className="url-label">Project ID</label>
                                    {/* <span className='text-mandatory fs-16 ml-1'><b>*</b></span> */}
                                    <input onChange={handleChange} value={inputs?.project_id} name="project_id" className="form-control form-control-bordered" />
                                    {/* {submitFlag && !inputs?.project_id &&
                                        <div className="text-danger my-2">Please Enter Project ID</div>
                                    } */}
                                </div>
                            }
                            <div className="col-md-4 mb-3">
                                <label className="url-label">Site ID</label>
                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                <input type="text" value={inputs?.site_id} name="site_id" onChange={handleChange} className="form-control form-control-bordered" />
                                {submitFlag && !inputs?.site_id &&
                                    <div className="text-danger my-2">Please Enter Site ID</div>
                                }
                            </div>
                        </div >
                        {(urlData?.uploadTo || urlData) &&
                            <div className="col-md-4 mb-3">
                                <label className="url-label">Upload to</label>
                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                <select
                                    className="form-control form-control-bordered"
                                    placeholder="placeholder"
                                    onChange={handleChange}
                                    name="uploadTo"
                                    value={inputs?.uploadTo || ""}
                                >
                                    <option value="">Select</option>
                                    {
                                        urlData?.uploadTo && urlData?.uploadTo?.map((item: any, index: number) => {
                                            return (
                                                <>
                                                    {item?.selected === true ?
                                                        <option value={item.value} key={index} selected>{item.label}</option>
                                                        :
                                                        <option value={item.value} key={index}>{item.label}</option>
                                                    }
                                                </>
                                            )
                                        }
                                        )
                                    }
                                </select>
                                {submitFlag && !inputs?.uploadTo &&
                                    <div className="text-danger my-2">Please Select Upload To</div>
                                }
                            </div>
                        }
                        {inputs?.uploadTo === "mqtt" &&
                            <>
                                <div className="row">
                                    <div className="col-4">
                                        <label >MQTT Host</label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <input
                                            type="text"
                                            name="MQTTHost"
                                            value={inputs?.MQTTHost}
                                            onChange={handleChange}
                                            className="form-control form-control-bordered"
                                        />
                                        {submitFlag && !inputs?.MQTTHost &&
                                            <div className="text-danger my-2">Please Enter MQTT Host</div>
                                        }
                                    </div>
                                    <div className="col-4">
                                        <div>
                                            <label >MQTT Port : </label>
                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                            <input
                                                type="number"
                                                name="MQTTPort"
                                                value={inputs?.MQTTPort}
                                                onChange={handleChange}
                                                className="form-control form-control-bordered"
                                            />
                                            {submitFlag && !inputs?.MQTTPort &&
                                                <div className="text-danger my-2">Please Enter MQTT Port</div>
                                            }
                                        </div>
                                        <div className="ml-2">
                                            <div className="mt-2">
                                                <label >UserName : </label>
                                                <input
                                                    type="text"
                                                    name="userName"
                                                    value={inputs?.userName}
                                                    onChange={handleChange}
                                                    className="form-control form-control-bordered"
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <label >Password : </label>
                                                <input
                                                    type="text"
                                                    name="password"
                                                    value={inputs?.password}
                                                    onChange={handleChange}
                                                    className="form-control form-control-bordered"
                                                />
                                            </div >
                                            <div className="mt-2">
                                                <label >MQTT Topic : </label>
                                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                <input
                                                    type="text"
                                                    name="MQTTTopic"
                                                    value={inputs?.MQTTTopic}
                                                    onChange={handleChange}
                                                    className="form-control form-control-bordered"
                                                />
                                                {submitFlag && !inputs?.MQTTTopic &&
                                                    <div className="text-danger my-2">Please Enter MQTT Topic</div>
                                                }
                                            </div>
                                            {/* <div className="custom-control custom-switch">
                                    <label >SSL/TLS : </label>
                                    <input type="checkbox" checked={true} className="custom-control-input" />
                                </div> */}
                                            <div className="mt-2">
                                                <label >SSL/TLS : </label>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        name="ssl_tls"
                                                        key={Math.random()}
                                                        checked={inputs?.ssl_tls || false}
                                                        onChange={(e) => { handleCheckBox(e) }}
                                                        className="custom-control-input"
                                                    />
                                                    <label className="custom-control-label mt-1"></label>
                                                    {/* <label className="custom-control-label" >Toggle this switch element</label> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {inputs?.uploadTo === "azure" &&
                            <>
                                <div className="row">
                                    <div className="col-6">
                                        <label >IOT Hub Server</label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <input
                                            type="text"
                                            name="IoTHubServer"
                                            value={inputs?.IoTHubServer}
                                            onChange={handleChange}
                                            className="form-control form-control-bordered"
                                        />
                                        {submitFlag && !inputs?.IoTHubServer &&
                                            <div className="text-danger my-2">Please Enter IOT Hub Server</div>
                                        }
                                    </div>
                                    <div className="col-6">
                                        <label >Device Key</label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <input
                                            type="text"
                                            name="deviceKey"
                                            value={inputs?.deviceKey}
                                            onChange={handleChange}
                                            className="form-control form-control-bordered"
                                        />
                                        {submitFlag && !inputs?.deviceKey &&
                                            <div className="text-danger my-2">Please Enter Device Key</div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        {inputs?.uploadTo === "aws" &&
                            <>
                                <div className="row my-2">
                                    <div className="col-7">
                                        <label >AWS MQTT Server Address</label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <input
                                            type="text"
                                            name="awsMQTTAddress"
                                            value={inputs?.awsMQTTAddress}
                                            onChange={handleChange}
                                            className="form-control form-control-bordered"
                                        />
                                        {submitFlag && !inputs?.awsMQTTAddress &&
                                            <div className="text-danger my-2">Please Enter AWS MQTT Server Address</div>
                                        }
                                    </div>
                                </div>
                                <div className="row my-2">
                                    <div className="col-6">
                                        <label className="mb-1">Certificate :</label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <textarea
                                            typeof="text"
                                            name="certificate"
                                            value={inputs?.certificate}
                                            onChange={handleChange}
                                            className="form-control text-box textbox-log"
                                            rows={5}
                                        >
                                        </textarea>
                                        {submitFlag && !inputs?.certificate &&
                                            <div className="text-danger my-2">Please Enter Certificate</div>
                                        }
                                    </div>
                                    <div className="col-6">
                                        <label className="mb-1">Key : </label>
                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                        <textarea
                                            typeof="text"
                                            name="key"
                                            value={inputs?.key}
                                            onChange={handleChange}
                                            className="form-control text-box textbox-log"
                                            rows={5}
                                        >
                                        </textarea>
                                        {submitFlag && !inputs?.key &&
                                            <div className="text-danger my-2">Please Enter Key</div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                        {inputs?.uploadTo === "http" &&
                            <>
                                <div className="d-flex mb-3">
                                    <span className="font-weight-bold m-auto-2">URLS</span>
                                    <button className="btn btn-subtle-dark br-4 mx-4" onClick={addContainerTableRows}>
                                        <span >Add URL  <FontAwesomeIcon icon={faPlus} />
                                        </span>
                                    </button>
                                </div>
                                <div>
                                    {rowsData.map((data: any, index: number) => {
                                        const { url } = data;
                                        return (
                                            <div className=" m-2 add-url">
                                                <div className="d-flex">
                                                    <label className="url-label">Url {index + 1}</label>
                                                    <div onClick={() => (deleteTableRows(index))} className="pointer">
                                                        <FontAwesomeIcon icon={faMinus} className="mx-4" />
                                                    </div>
                                                </div>
                                                <input
                                                    type="text"
                                                    value={url ? url : ""}
                                                    onChange={(evnt) => (handleChangeURL(index, evnt))}
                                                    name="url"
                                                    className="form-control"
                                                />
                                            </div>
                                            // { finalSubmit && !rowsData[index].url && rowsData[index].url !== 0 && <div className="text-danger" attr-test="error-text">{languageData?.url} </div> }
                                            // { finalSubmit && (rowsData[index].url <= 0) && <div className="text-danger" attr-test="error-text">{validateNegativeNumbers(rowsData[index].url, languageData)}</div> }

                                        )
                                    })
                                    }
                                </div>
                                {rowsData.length >= 4 &&
                                    <div className="text-danger" attr-test="error-text">You can add maximum of 4 URL Only</div>
                                }
                            </>
                        }
                    </>
                    :
                    <Loader hasError={false} />
                }

            </div>
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => onClose && onClose(false)}>Close</button>
                    <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={saveAddUrl}>Save</button>
                </div>
            </div>
        </>
    )
}
export default AddUrl;